import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function StartupRedirect () {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const path = params.get('path');
    const tenant = params.get('tenant');

    if (path && location.pathname === '/') {
      const fullPath = `${path}?tenant=${tenant}`;
      navigate(fullPath, { replace: true });
    }
  }, [location, navigate]);

  return null;
};
